<div class="background-white">
    <div class="close-left-x padding-1 pb-1-5rem-imp" aria-label="CloseFullScreen" role="form" tabindex="0" *ngIf="crossRef" >
      <div role="button" class="ml-1 back-close-btn" tabindex="0" (click)="crossRefBack()" (keyup.enter)="crossRefBack()" >
        <img src="../../../assets/icons/arrow-left-blue.svg" class="content-page-back-arrow-icon" alt="Arrow Left">
        <span class="border-bottom-help">
          Back to Cross Reference Report Results
        </span>
      </div>
    </div>
    <div class="close-left-x padding-1 pb-1-5rem-imp" aria-label="CloseFullScreen" role="form" tabindex="0" *ngIf="GlossaryTerm">
      <div role="button" class="ml-1 back-close-btn" tabindex="0" (click)="glossaryBack()" (keyup.enter)="glossaryBack()">
        <img src="../../../assets/icons/arrow-left-blue.svg" class="content-page-back-arrow-icon" alt="Arrow Left">
        <span class="border-bottom-help">
          Back to Master Glossary
        </span>
      </div>
    </div>
    <div class="close-left-x padding-1 pb-1-5rem-imp" aria-label="CloseFullScreen" role="form" tabindex="0" *ngIf="WhatLinksHere">
      <div role="button" class="ml-1 back-close-btn" tabindex="0" (click)="backToWhatLinksHerePage()" (keyup.enter)="backToWhatLinksHerePage()" tabindex="0">
        <img src="../../../assets/icons/arrow-left-blue.svg" class="content-page-back-arrow-icon" alt="Arrow Left">
        <span class="border-bottom-help">Back to {{whatLinksHereTitle.replace("-null","")}}</span>
      </div>
    </div>
    <div class="close-left-x padding-1 pb-1-5rem-imp" aria-label="CloseFullScreen" role="form" tabindex="0" *ngIf="Xbrl">
      <div role="button" class="ml-1 back-close-btn" tabindex="0" (click)="XbrlBack()" (keyup.enter)="XbrlBack()">
        <img src="../../../assets/icons/arrow-left-blue.svg" class="content-page-back-arrow-icon" alt="Arrow Left">
        <span class="border-bottom-help" >
          Back to {{backPathText}}
        </span>
      </div>
    </div>
</div>
